import { ReactComponent as DragMenu } from "../../../../assets/svgIcon/listView/dragmenu.svg";
import { ReactComponent as Close } from "../../../../assets/svgIcon/listView/Close.svg";
import { useState } from "react";
import { useUpdateCurrentViewOrDetailsMutation } from "../../../../../../store/apiSlice/newInterfaceApiSlice";
import { moduleForView } from "../../../utils/tableDataElements";
import { CreateViewCss } from "../../CreateView/CreateView";
import { CreateViewDrawer } from "../../CreateView/CreateViewDrawer";
import { BlurModal } from "../../BlurModal/BlurModal";

export const EditColumn = ({
  headerList = [],
  setHeaderList,
  closeEditColumn,
  orderType,
  asDrawer = false,
}) => {
  const [headerListLocal, setHeaderListLocal] = useState(headerList);
  const [selectedViewItem, setSelectedViewItem] = useState(headerList.filter(item => item.checked));
  const [updateColumnDetails] = useUpdateCurrentViewOrDetailsMutation();

  const handleSelectViewOption = e => {
    if (e.target.value === "selectAll") {
      if (e.target.checked) {
        const headers = headerList.map(item => ({
          ...item,
          checked: true,
        }));
        setHeaderListLocal(headers);
        setSelectedViewItem(headers);
      } else {
        setHeaderListLocal(
          headerList.map(item => ({
            ...item,
            checked: false,
          })),
        );
        setSelectedViewItem([]);
      }
      return;
    }

    setHeaderListLocal(
      headerListLocal.map(item =>
        item.columnName === e.target.value ? { ...item, checked: e.target.checked } : item,
      ),
    );
    if (e.target.checked)
      setSelectedViewItem([...selectedViewItem, { columnName: e.target.value }]);
    else setSelectedViewItem(selectedViewItem.filter(item => item.columnName !== e.target.value));
  };

  const handleSelectRightSide = e => {
    if (!e.target.checked) {
      setSelectedViewItem(selectedViewItem.filter(item => item.columnName !== e.target.value));
      setHeaderListLocal(
        headerListLocal.map(item =>
          item.columnName === e.target.value ? { ...item, checked: false } : item,
        ),
      );
    }
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    if (dragIndex !== null && dragIndex !== dropIndex) {
      const updatedItems = [...selectedViewItem];
      const draggedItem = updatedItems.splice(dragIndex, 1)[0];
      updatedItems.splice(dropIndex, 0, draggedItem);
      setSelectedViewItem(updatedItems);
    }
  };

  const handleDragOver = e => {
    e.preventDefault();
  };

  const handleSubmit = () => {
    setHeaderList(headerListLocal);
    updateColumnDetails({
      column_for_detail: selectedViewItem.map(item => item.columnName),
      module: moduleForView[orderType],
    });
    closeEditColumn();
  };

  const handleSelectForWarning = () => {};

  const columnEditor = (
    <CreateViewCss className={asDrawer ? "inDrawer editColumns" : "editColumns"}>
      {!asDrawer && (
        <header>
          Edit Columns
          <Close onClick={closeEditColumn} />
        </header>
      )}
      <main>
        <div className="detailsOfView">
          <div className="leftSide">
            <div onClick={handleSelectViewOption} className="availableColumn">
              <p>Available Columns</p>
              <div>
                <label className="selectAll">
                  <input
                    type="checkbox"
                    value="selectAll"
                    checked={headerList.length === selectedViewItem.length}
                  />
                  SELECT ALL
                </label>
                {headerList.map(item => (
                  <label key={item.columnName}>
                    <input
                      type="checkbox"
                      onChange={handleSelectForWarning}
                      checked={selectedViewItem?.some(name => name.columnName === item.columnName)}
                      value={item.columnName}
                    />
                    {item.columnName}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="rightSide">
            <p>Selected Columns</p>
            <div className="selectedColumns ">
              {selectedViewItem?.map((item, index) => (
                <label
                  draggable
                  onDragStart={e => handleDragStart(e, index)}
                  onDragOver={handleDragOver}
                  onDrop={e => handleDrop(e, index)}
                  key={item.columnName}
                  className="item"
                >
                  <DragMenu />
                  <input
                    type="checkbox"
                    checked
                    value={item.columnName}
                    onChange={handleSelectRightSide}
                  />
                  {item.columnName}
                </label>
              ))}
            </div>
          </div>
        </div>
      </main>

      <footer>
        <button type="button" className="cancelBtn" onClick={closeEditColumn}>
          Cancel
        </button>
        <button
          type="button"
          className="applyBtn"
          disabled={selectedViewItem.length === 0}
          onClick={handleSubmit}
        >
          Apply
        </button>
      </footer>
    </CreateViewCss>
  );

  if (asDrawer) {
    return (
      <CreateViewDrawer isOpen title="Edit Columns" onClose={closeEditColumn}>
        {columnEditor}
      </CreateViewDrawer>
    );
  }

  return <BlurModal>{columnEditor}</BlurModal>;
};
